import scrollAnimationsInit from './scroll-animations';
import navigationInit from './navigation';

document.addEventListener('DOMContentLoaded', () => {
    scrollAnimationsInit();
    navigationInit();
})
